import { render, staticRenderFns } from "./TiersTable.vue?vue&type=template&id=1ee1c0be&scoped=true&"
import script from "./TiersTable.vue?vue&type=script&lang=js&"
export * from "./TiersTable.vue?vue&type=script&lang=js&"
import style0 from "./TiersTable.vue?vue&type=style&index=0&id=1ee1c0be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee1c0be",
  null
  
)

export default component.exports